import { render, staticRenderFns } from "./AddPurchaseOrder.vue?vue&type=template&id=040ac915"
import script from "./AddPurchaseOrder.vue?vue&type=script&lang=js"
export * from "./AddPurchaseOrder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports